// ABOUTME: Toggle behavior for jf-shortcode accordion rows — mirrors the live DTC
// accordionHandler (active class + inline max-height), with keyboard activation added.
const toggle = (title) => {
  const panel = title.nextElementSibling;
  if (!panel || !panel.classList.contains('jf-sc-accordion__panel')) return;
  title.classList.toggle('active');
  const open = title.classList.contains('active');
  title.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (panel.style.maxHeight) {
    panel.style.maxHeight = null;
  } else {
    panel.style.maxHeight = `${panel.scrollHeight}px`;
  }
};

document.addEventListener('click', (event) => {
  const title = event.target.closest('.jf-sc-accordion__title');
  if (title) toggle(title);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  const title = event.target.closest('.jf-sc-accordion__title');
  if (title) {
    event.preventDefault();
    toggle(title);
  }
});
